
import BlankLayout from "@/layouts/BlankLayout.vue";
import PlatformLayout from "@/components/components_platform/PlatformLayout.vue";

import CmsLayout from "@/modules/cms/layouts/CmsLayout.vue";
import CmsRoute from "@/modules/cms/routes/CmsRoute";

const routes = [
  {
    path:'/',
    component:PlatformLayout,
    // component:()=> import('@/modules/workorder/pages/index/index.vue'),
    children:[
      {
        path: '/',
        component:() => import('@/pages/index/index.vue'),
        meta:{title:'工作台'},
      },
    ]
  },
  {
    path:'/cms',
    component:CmsLayout,
    // component:()=> import('@/modules/workorder/pages/index/index.vue'),
    children:CmsRoute
  },
  {
    path:'/login',
    component:BlankLayout,
    children:[
      {
        path: '/login/index',
        name:'login',
        component:() => import('@/pages/login/index.vue'),
      },
      {
        path: '/wechat/callback',
        name:'wechatCallback',
        component:() => import('@/pages/login/WechatCallback.vue'),
      },

    ]
  },
]
export default routes